import { api } from "../api";
import { store } from "../store";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

async function deleteWorkbook(id: number): Promise<void> {
    if (api.clientApi) {
        await api.clientApi.clientWorkbookDelete(store.db ? store.db : "", id).then((response) => {
            if (response instanceof Error || (response.message && response.message.error)) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response);
                } else {
                    store.doNotice(lang[response.message.error]);
                }
            }
        });
    }
}

export { deleteWorkbook };
